import { ButtonContainer } from "../../generic-sprites/Buttons"
import { PersonalityType } from "./PersonalityType"


export interface PersonalityChoices {
    quizAnswers: Array<PersonalityType>
    personalityType: PersonalityType
    articleTitle: string
    blanks: Array<string>
}

export interface PersonalityStoreRefs {
    storyFinishedButton: ButtonContainer
}

export class PersonalityStore {
    private static innerInstance: PersonalityStore
    private studentChoices: PersonalityChoices = {
        quizAnswers: [],
        personalityType: PersonalityType.KIND_HELPFUL,
        articleTitle: "",
        blanks: [],
    }
    private storeRefs: PersonalityStoreRefs = {
        storyFinishedButton: undefined,
    }

    static get instance() {
        return this.innerInstance || (
            this.innerInstance = new this()
        )
    }

    static newInstance() {
        return this.innerInstance = new this()
    }

    get quizAnswers(): Array<PersonalityType> {
        return this.studentChoices.quizAnswers
    }

    set quizAnswer(answer: { personalityType: PersonalityType, index: number }) {
        const {personalityType, index} = answer
        if (index >= 0 && index < 5) {
            this.studentChoices.quizAnswers[index] = personalityType
        }
    }

    get personalityType(): PersonalityType {
        return this.studentChoices.personalityType
    }

    set personalityType(personalityType: PersonalityType) {
        this.studentChoices.personalityType = personalityType
    }

    get articleTitle(): string {
        return this.studentChoices.articleTitle
    }

    set articleTitle(articleTitle: string) {
        this.studentChoices.articleTitle = articleTitle
    }

    get blanks(): Array<string> {
        return this.studentChoices.blanks
    }

    set blank(blank: { text: string, index: number }) {
        const {text, index} = blank
        if (index >= 0 && index < 5) {
            this.studentChoices.blanks[index] = text
        }
    }

    get storyFinishedButton(): ButtonContainer {
        return this.storeRefs.storyFinishedButton
    }

    set storyFinishedButton(button: ButtonContainer) {
        this.storeRefs.storyFinishedButton = button
    }
}